import React from 'react';
import { OrderCounts } from '../../lib/types';

interface StatCardsProps {
  counts: OrderCounts;
  filterStatus: string;
  setFilterStatus: (v: string) => void;
}

const ICONS = {
  pending: (
    <svg viewBox="0 0 16 16" width="14" height="14">
      <circle cx="8" cy="8" r="6" fill="none" stroke="var(--red)" strokeWidth="1.5" />
      <path d="M8 5v3.5" stroke="var(--red)" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11" r="0.8" fill="var(--red)" />
    </svg>
  ),
  ordered: (
    <svg viewBox="0 0 16 16" width="14" height="14">
      <rect x="3" y="2" width="10" height="12" rx="2" fill="none" stroke="var(--blue)" strokeWidth="1.5" />
      <path d="M6 6h4M6 9h2.5" stroke="var(--blue)" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  delivered: (
    <svg viewBox="0 0 16 16" width="14" height="14">
      <path d="M4 8.5l2.5 2.5L12 5" fill="none" stroke="var(--teal)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  closed: (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="var(--text2)" strokeWidth="1.3">
      <rect x="2" y="3"  width="5" height="5" rx="1.5" />
      <rect x="9" y="3"  width="5" height="5" rx="1.5" />
      <rect x="2" y="10" width="5" height="5" rx="1.5" />
      <rect x="9" y="10" width="5" height="5" rx="1.5" />
    </svg>
  ),
};

interface CardConfig {
  key: 'pending' | 'ordered' | 'delivered' | 'closed';
  label: string;
  className: string;
  iconBg: string;
  activeBorder: string;
}

const CARDS: CardConfig[] = [
  { key: 'pending',   label: 'Pending',  className: 'sc cr', iconBg: 'var(--red-bg)',     activeBorder: 'var(--red)' },
  { key: 'ordered',   label: 'On order', className: 'sc cb', iconBg: 'var(--blue-bg)',    activeBorder: 'var(--blue)' },
  { key: 'delivered', label: 'Delivered',className: 'sc cg', iconBg: 'var(--teal-bg)',    activeBorder: 'var(--teal)' },
  { key: 'closed',    label: 'Closed',   className: 'sc cn', iconBg: 'var(--surface2)',   activeBorder: 'var(--text2)' },
];

export function StatCards({ counts, filterStatus, setFilterStatus }: StatCardsProps) {
  return (
    <div
      className="stats-bar"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 10, padding: 0, marginBottom: 12, background: 'transparent',
      }}
    >
      {CARDS.map(card => {
        const active = filterStatus === card.key;
        return (
          <div
            key={card.key}
            className={card.className}
            onClick={() => setFilterStatus(active ? 'all' : card.key)}
            style={{
              cursor: 'pointer',
              border: `2px solid ${active ? card.activeBorder : 'transparent'}`,
              transition: 'border-color var(--dur-fast) var(--ease)',
            }}
            title={`Show ${card.label.toLowerCase()} only`}
          >
            <div className="flex items-center justify-between" style={{ marginBottom: 6 }}>
              <div className="sl">{card.label}</div>
              <div
                style={{
                  width: 28, height: 28, background: card.iconBg,
                  borderRadius: 'var(--r)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
              >{ICONS[card.key]}</div>
            </div>
            <div className="sn">{counts[card.key]}</div>
          </div>
        );
      })}
    </div>
  );
}
